var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from 'react';
import classnames from 'classnames';
import { observer } from 'mobx-react';
import styles from './FormTextArea.styl';
import TextAreaField from '../TextAreaField/TextAreaField';
let FormTextArea = class FormTextArea extends React.Component {
    render() {
        const { className, fieldClassName, containerClassName, hideLabelInner, errorPosition, field, type, t, maxLength, showPlaceholder } = this.props;
        const errorClassName = classnames(styles.errorText, styles[`error${errorPosition}`]);
        const hasError = field.hasError;
        const error = field.error;
        const props = {
            ...field.bind(),
            maxLength,
            error,
            showPlaceholder,
            hideLabelInner,
            label: t(field.label),
            placeholder: t(field.placeholder)
        };
        return (React.createElement("div", { className: classnames(styles.field, className) },
            React.createElement(TextAreaField, { ...props, className: containerClassName, fieldClassName: fieldClassName, type: type }),
            hasError && error ? (React.createElement("span", { className: errorClassName }, error)) : false));
    }
};
Object.defineProperty(FormTextArea, "defaultProps", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: {
        className: '',
        fieldClassName: '',
        errorPosition: 'BottomLeft',
        t: () => { }
    }
});
FormTextArea = __decorate([
    observer
], FormTextArea);
export default FormTextArea;
